import React from 'react';

// Font Awesome Free v7.3.1 (solid calendar), CC BY 4.0 —
// https://fontawesome.com/license/free. Matches the FA icons used across the
// student screens (see FaClockIcon, FaVideoIcon).
const FaCalendarIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" {...props}>
    <path d="M152 24c0-13.3-10.7-24-24-24S104 10.7 104 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z" />
  </svg>
);

export default FaCalendarIcon;
